export default __webpack_public_path__ + "72f168da2f7bd24ef01d0582c755d28e.svg";